import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Download, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-10 pb-14 lg:pt-16 lg:pb-20 overflow-hidden bg-brand-cream bg-noise" data-id="element-118">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-119">
        {/* Mobile-only headline above the image */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="lg:hidden text-4xl sm:text-5xl font-serif font-bold text-brand-navy leading-tight mb-8 text-center" data-id="element-120">
          El Método "Fuego Cero":{' '}
          <span className="text-brand-gold" data-id="element-121">
            Desinflama tu abdomen en 7 días
          </span>{' '}
          sin dejar de comer lo que te gusta.
        </motion.h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-122">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl order-2 lg:order-1" data-id="element-123">
            {/* Desktop-only headline */}
            <h1 className="hidden lg:block text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-navy leading-tight mb-6" data-id="element-124">
              El Método "Fuego Cero":{' '}
              <span className="text-brand-gold" data-id="element-125">
                Desinflama tu abdomen en 7 días
              </span>{' '}
              sin dejar de comer lo que te gusta.
            </h1>

            <h2 className="text-lg sm:text-xl text-brand-navy/80 font-medium mb-6 leading-relaxed" data-id="element-126">
              La guía definitiva para la mujer chilena de +40 que quiere
              eliminar la hinchazón abdominal y recuperar su energía con
              ingredientes del supermercado local.
            </h2>

            <p className="text-base sm:text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-127">
              ¿Te ha pasado que te despiertas con el abdomen plano, pero al
              llegar la tarde sientes que el botón del pantalón va a explotar?
              No es que hayas subido de peso de un día para otro. Es inflamación
              crónica, y a los 40 años, tu cuerpo ya no procesa la dieta chilena
              tradicional como antes.
            </p>

            <div className="space-y-4" data-id="element-128">
              <Button className="text-lg w-full sm:w-auto" data-id="element-129">
                ¡SÍ, QUIERO DESINFLAMAR MI ABDOMEN AHORA!
              </Button>

              <div className="flex flex-wrap items-center gap-4 text-sm text-brand-navy/70 mt-4" data-id="element-130">
                <div className="flex items-center gap-1" data-id="element-131">
                  <Download size={16} className="text-brand-green" data-id="element-132" />
                  <span data-id="element-133">Descarga digital instantánea</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-134">
                  <ShieldCheck size={16} className="text-brand-green" data-id="element-135" />
                  <span data-id="element-136">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-137">
                  <Users size={16} className="text-brand-green" data-id="element-138" />
                  <span data-id="element-139">Para mujeres chilenas +40</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-xs sm:max-w-md lg:max-w-full order-1 lg:order-2" data-id="element-140">
            <motion.div animate={{
            y: [-10, 10, -10]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/qnXyCi8Wh4bwVuRp1MBxsU/mockup.png" alt="Portada del eBook Método Fuego Cero Antinflamatorio 15-Min" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-142" />
            </motion.div>
            {/* Decorative background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-gold/10 rounded-full blur-3xl -z-10" data-id="element-143"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}